import Cookie from "js-cookie"
const state = {

};

export default state



// WEBPACK FOOTER //
// ./src/store/state.js